import { type FC } from 'react'

import { Skeleton } from '@/components/ui/skeleton.tsx'
import { classNames } from '@/utils/helpers.ts'

interface Props {
  itemClassName?: string
}

export const VaultCategoriesSkeleton: FC<Props> = ({ itemClassName }) => {
  return (
    <div className="mt-3">
      {Array.from({ length: 4 }).map((_, i) => (
        <Skeleton
          key={i}
          className={classNames(
            'mb-1 h-[70px] w-full dark:bg-neutral-800',
            itemClassName,
          )}
        />
      ))}
    </div>
  )
}
